import React from 'react'
import {withStyles} from '@material-ui/core';
import PropTypes from 'prop-types';
import Tr from 'translations/Translations';
import TextInput from 'components/TextInput';
import RadioGroup from 'components/RadioGroup';
import Select, {createSelectItem} from 'components/Select';
import GridBlock from 'components/GridBlock';
import primaryTenderVariantValues from './fieldsOptions/primaryTenderVariant.values'
import orderTypeValues from 'constants/orderType.values'
import InputLimits from 'constants/InputLimits';
import HelpComponent from 'components/HelpComponent';
import getObjectValue from 'libs/getObjectValue';
import {isDemandPreparing} from "libs/getDemandStatus";
import OrganizationInput from "components/OrganizationInput";
import {isNationalProcedure} from "constants/ProcedureType";
import NetGrossField from "components/NetGrossField";
import TitledComponent from "components/TitledComponent";
import INPUT_TYPE from 'constants/INPUT_TYPE';
import {DemandCategoryTypeLabel, DemandCategoryTypesForProcedure} from "constants/DemandCategoryType";


const limits = InputLimits.procedure.basicInformation;

const style = theme => ({
    root: {}
})

function ExPostFields(
    {
        formikProps,
        demandAvailableOrganizations,
        demandRealizationTypes,
        numberAutomated,
        demandHeader,
    }) {
    const creatingDemand = getObjectValue('identity', formikProps.values, false) <= 0 || isDemandPreparing();
    const procedureType = getObjectValue('procedureType', formikProps.values, "");
    const nationalProcedure = isNationalProcedure(procedureType);
    const realizationType = getObjectValue('demandRealizationType', formikProps.values, "");
    const createItem = (prefix, value) => ({label: Tr(prefix + '.' + value), value});
    const demandRealizationTypesTranslated = demandRealizationTypes.map(x => createItem(procedureType, x.name));
    const demandCategoryType = getObjectValue("demandCategoryType", formikProps.values, null)
    
    const onDemandRealizationTypeChanged = (realizationType) => {

        if (realizationType === 'primary_tender') {
            formikProps.setFieldValue('primaryTenderVariant', primaryTenderVariantValues[0].value);
        }
    };

    return (
        <GridBlock
            column
        >
            <TextInput
                id='number'
                label={Tr('case_number')}
                formikProps={formikProps}
                required
                disabled={numberAutomated}
                limit={limits.NUMBER}
                showErrorImmediately
            />

            {
                (creatingDemand || !!demandCategoryType) && <Select
                    id='demandCategoryType'
                    label={Tr('demand_category_type')}
                    formikProps={formikProps}
                    items={DemandCategoryTypesForProcedure(procedureType).map(x => createSelectItem(x, DemandCategoryTypeLabel(x)))}
                    required
                />
            }

            {demandHeader?.applicationClientSettings?.ezdrpIntegration?.active &&
                <TextInput
                    id='ezdrpId'
                    label={Tr('case_ezdrpId')}
                    formikProps={formikProps}
                    limit={limits.NUMBER}
                    showErrorImmediately
                />
            }

            {demandHeader?.applicationClientSettings?.ezdpuwIntegration?.active &&
                <TextInput
                    id='ezdpuwId'
                    label={Tr('case_ezdpuwId')}
                    formikProps={formikProps}
                    limit={limits.NUMBER}
                    showErrorImmediately
                />
            }

            <OrganizationInput
                id='organization'
                formikProps={formikProps}
                required
                disabled={!creatingDemand || demandAvailableOrganizations.length < 2}
                availableOrganizations={demandAvailableOrganizations}
            />

            <TextInput
                id='name'
                label={Tr('proceedings_subject')}
                formikProps={formikProps}
                required
                limit={limits.NAME}
                multiline
                showErrorImmediately
            />

            <HelpComponent text={Tr('tooltip_realization_type')}>
                <Select
                    id='demandRealizationType'
                    label={Tr('proposed_procedure')}
                    formikProps={formikProps}
                    items={demandRealizationTypesTranslated}
                    onChange={e => onDemandRealizationTypeChanged(e.target.value)}
                    required
                    disabled={!creatingDemand}
                />
            </HelpComponent>

            {nationalProcedure && realizationType === 'primary_tender' &&
                <Select
                    id='primaryTenderVariant'
                    label={Tr('primary_tender_variant')}
                    formikProps={formikProps}
                    items={primaryTenderVariantValues}
                    required
                />
            }
            <RadioGroup
                id='demandOrderType'
                label={Tr('order_type')}
                formikProps={formikProps}
                items={orderTypeValues}
                required
            />

            <GridBlock>
                <NetGrossField
                    formikProps={formikProps}
                    title={Tr('estimated_value')}
                    id={'estimatedValue'}
                />
            </GridBlock>

            <TitledComponent
                title={Tr('realization_value')}
            >
                <GridBlock>
                    <TextInput
                        id={'realizationGrossValue'}
                        formikProps={formikProps}
                        label={Tr('gross')}
                        type={INPUT_TYPE.NUMBER_19}
                        step="0.01"
                    />
                    <div/>
                </GridBlock>
            </TitledComponent>

            <GridBlock>
                <NetGrossField
                    formikProps={formikProps}
                    title={Tr('realizated_value')}
                    id={'realizatedValue'}
                />
            </GridBlock>
        </GridBlock>
    )
}

ExPostFields.propTypes = {
    classes: PropTypes.any,
    formikProps: PropTypes.object,
};

ExPostFields.defaultProps = {};

export default withStyles(style)(ExPostFields);